<template>
  <div>
    <div class="container">
      <div class="row no-margin">
        <h5 class="overview-h5">{{ $t('service_call') }} - {{ $route.params.id }}</h5>
      </div>

      <div>
        <div class="row">
          <div class="col-sm-6">
            <dl class="row">
              <dt class="col-sm-5">{{ $t('subject') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.callSubject }}</dd>

              <dt class="col-sm-5">{{ $t('your_reference') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.externalReference }}</dd>

              <dt class="col-sm-5">{{ $t('action_date') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.createDateTime | moment("DD/MM/YYYY") }}</dd>

              <dt class="col-sm-5">{{ $t('action_time') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.createDateTime | moment("HH:mm:ss") }}</dd>

              <dt class="col-sm-12" style="height: 32px;">{{ $t('message') }}</dt>
              <dd class="col-sm-12" v-if="serviceCall.callMessage">{{ serviceCall.callMessage }}</dd>

              <dt class="col-sm-12" style="height: 32px;">{{ $t('solution') }}</dt>
              <dd class="col-sm-12" v-if="serviceCall.callSolution">{{ serviceCall.callSolution }}</dd>

              <dt class="col-sm-5">{{ $t('solution_reference') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.callSolutionRef }}</dd>

              <dt class="col-sm-5">{{ $t('planned_date') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.callPlannedDate | moment("DD/MM/YYYY") }}</dd>

              <dt class="col-sm-5">{{ $t('deadline_date') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.callDeadlineDate | moment("DD/MM/YYYY") }}</dd>

              <dt class="col-sm-5">{{ $t('realized_visit_date') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.callRealizedVisitDate | moment("DD/MM/YYYY") }}</dd>
            </dl>
          </div>
          <div class="col-sm-6">
            <div>
              <h5>{{ $t('service_object') }}</h5>
              <dl class="row">
                <dt class="col-sm-5">{{ $t('object') }}</dt>
                <dd class="col-sm-7 row-link" v-on:click="objectClick(serviceCall.serviceObjectId)">
                  {{ serviceCall.serviceObjectId }}</dd>

                <dt class="col-sm-5">{{ $t('description') }}</dt>
                <dd class="col-sm-7">{{ serviceCall.serviceObject.description || '' }}</dd>

                <dt class="col-sm-5">{{ $t('serialNo') }}</dt>
                <dd class="col-sm-7">{{ serviceCall.serviceObject.serialNo || '' }}</dd>
              </dl>
            </div>
            <div>
              <h5>{{ $t('contract') }}</h5>
              <dl class="row">
                <dt class="col-sm-5">{{ $t('contract') }}</dt>
                <dd class="col-sm-7 row-link" v-on:click="contractClick(serviceCall.serviceContractId)">
                  {{ serviceCall.serviceContractId }}</dd>

                <dt class="col-sm-5">{{ $t('contractType') }}</dt>
                <dd class="col-sm-7">{{ serviceCall.serviceObject.serviceContract.contractType || '' }}</dd>

                <dt class="col-sm-5">{{ $t('status') }}</dt>
                <dd class="col-sm-7">
                  <span v-if="serviceCall.serviceContractId != ''">{{ serviceCall.serviceObject.serviceContract.status ===
                    1 ? 'Active' : 'Stopped' }}</span>
                </dd>
              </dl>
            </div>
          </div>
        </div>

        <br class="d-none d-lg-block" />

        <div class="row">
          <div class="col-sm-6">
            <h5>{{ $t('visit_address') }}</h5>
            <dl class="row">
              <dt class="col-sm-5">{{ $t('region_code') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.regionCode }}</dd>

              <dt class="col-sm-5">{{ $t('site') }}</dt>
              <dd class="col-sm-7">
                <pre class="visit-address">{{ serviceCall.visitAddress }}</pre>
              </dd>
            </dl>
          </div>

          <div class="col-sm-6">
            <h5>{{ $t('call_status') }}</h5>
            <dl class="row">
              <dt class="col-sm-5">{{ $t('status') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.callStatus }}</dd>

              <!-- <dt class="col-sm-5">{{ $t('number') }}</dt>
              <dd class="col-sm-7">{{serviceCall.callId}}</dd>-->

              <dt class="col-sm-5">{{ $t('contractType') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.callType }}</dd>

              <!-- <dt class="col-sm-5">{{ $t('open_service_call') }}</dt>
              <dd class="col-sm-7">{{serviceCall.openServiceCall ? $t('open') : $t('closed')}}</dd>-->

              <dt class="col-sm-5">{{ $t('received_by') }}</dt>
              <dd class="col-sm-7">{{ serviceCall.receivedBy }}</dd>
            </dl>
          </div>
        </div>

        <!-- <br class="d-none d-lg-block" /> -->

        <div class="row">
          <div class="col-sm-12">
            <h5>{{ $t('documents') }}</h5>
            <dl class="row">
              <dd class="col-sm-12" v-for="(document, index) in callDocuments" v-bind:key="index">
                <font-awesome-icon :icon="['fas', 'times']"
                  style="color: #dc3545; cursor: pointer; margin-right: 8px; text-decoration: none;"
                  @click="requestDelete(document)" v-if="canDelete(document)" />
                <span>{{ document.documentType ? '[' + document.documentType + '] &nbsp;' : '' }}</span>
                <span class="document-link" v-on:click="downloadDocument(document)">{{ document.friendlyName }} </span>
                <span>{{ document.legacy ? ' (Legacy)' : '' }}</span>
              </dd>
              <dd class="col-sm-12" v-if="!callDocuments">
                <span>{{ $t('there_no_linked_documents_service_call') }}</span>
              </dd>
            </dl>
          </div>

          <b-modal id="delete-document" ref="modal" title="Verwijderen document">
            <p class="my-2">{{ $t('are_you_sure_you_want_to_delete_this_document') }}</p>
            <p class="my-2" v-show="showDocumentNotFound" style="color: #dc3545;">{{
              $t('document_not_found_on_the_server') }}</p>

            <template v-slot:modal-footer>
              <b-button variant="outline-secondary" @click="hideModal()">{{ $t('cancel_2') }}</b-button>
              <b-button variant="danger" @click="deleteDocument()">{{ $t('delete') }}</b-button>
            </template>
          </b-modal>
        </div>

        <br class="d-none d-lg-block" />
      </div>
    </div>
  </div>
</template>

<script>
import { user } from './../../user';
import { SharePointService } from './../../services/sharepoint.service';

export default {
  name: 'ServiceCallDetail',
  data: function () {
    return {
      document: null,
      serviceCall: {
        callDocuments: [],
        serviceObject: {
          serviceContract: {}
        }
      },
      showDocumentNotFound: false,
      canDeleteDocument: false,
      callDocuments: []
    };
  },
  methods: {
    objectClick: function (objectNr) {
      this.$router.push({
        name: 'service-object',
        params: {
          id: objectNr
        }
      });
    },
    contractClick: function (contractNr) {
      this.$router.push({
        name: 'service-contract',
        params: {
          id: contractNr
        }
      });
    },
    requestDelete(document) {
      this.document = document;
      this.$refs.modal.show();
    },
    canDelete() {
      return this.canDeleteDocument;
    },
    deleteDocument: function () {
      this.showDocumentNotFound = false;

      if (this.document.legacy) {
        var promise = this.$axios.post(
          'servicecalls/deletedocument',
          this.document,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        promise
          .then(data => {
            this.callDocuments = this.callDocuments.filter(
              item => item.documentName !== this.document.documentName
            );

            this.document = null;

            this.$refs.modal.hide();
          })
          .catch(error => {
            if (error.response.status === 404) {
              this.showDocumentNotFound = true;
            }
          });
      } else {
        const sharePointService = new SharePointService(user);

        sharePointService.initialize()
          .then(async () => {
            sharePointService.updateListItemVisibility(this.document.listId, this.document.id).then(() => {
              this.callDocuments = this.callDocuments.filter(
                item =>
                  item.friendlyName !== this.document.friendlyName ||
                  (item.friendlyName === this.document.friendlyName && item.legacy !== this.document.legacy)
              );

              this.document = null;

              this.$refs.modal.hide();
            })
          });
      }
    },
    hideModal: function () {
      this.document = null;
      this.showDocumentNotFound = false;

      this.$refs.modal.hide();
    },
    downloadDocument: async function (document) {
      try {
        let documentName = '';
        let blob;

        if (document.legacy) {
          documentName = encodeURIComponent(document.documentName);

          // Download from the legacy service
          const response = await this.$axios({
            url: `servicecalls/document?serviceCallId=${this.$route.params.id}&documentName=${documentName}`,
            method: 'GET',
            responseType: 'blob'
          });
          blob = new Blob([response.data]);
        } else {
          documentName = document.friendlyName;

          const sharePointService = new SharePointService(user);
          await sharePointService.initialize();

          blob = await sharePointService.downloadFile(document.listId, document.id, document.friendlyName);
        }

        // Common download logic for both legacy and SharePoint service
        downloadDocument(blob, documentName);

      } catch (error) {
        console.error('Error downloading document:', error);
      }

      return;

      function downloadDocument(blob, documentName) {
        if (navigator.msSaveBlob) {
          // For Internet Explorer
          navigator.msSaveBlob(blob, documentName);
        } else {
          const url = window.URL.createObjectURL(blob);
          const link = window.document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentName);
          window.document.body.appendChild(link);
          link.click();
          window.document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      }
    }
  },
  created() {
    var serviceCallId = this.$route.params.id;

    getServiceCall(this, serviceCallId);
  }
};

function getServiceCall(context, serviceCallId) {
  let promise = context.$axios.get(
    'servicecalls?serviceCallId=' + serviceCallId
  );

  return promise
    .then(data => {
      context.serviceCall = data.data;

      context.serviceCall.callDocuments.forEach(item => {
        item.legacy = true;
      });

      const sharePointService = new SharePointService(user);

      const fetchAndProcessDocuments = async (listName, query) => {
        const documents = []; // New array to store the documents

        try {
          const listId = await sharePointService.getListIdByName(listName);
          if (!listId) {
            console.warn(`List '${listName}' not found.`);

            return documents;
          }

          const items = await sharePointService.getItemsForList(listId, query);
          if (!items || items.length === 0) {
            // console.log(`No items found in list '${listName}' with query: ${query}`);

            return documents;
          }

          items.forEach(item => {
            documents.push({
              legacy: false,
              listId: listId,
              id: item.id,
              friendlyName: item.fields.DocumentName || item.fields.FileLeafRef,
              documentType: item.fields.DocumentType,
              date: item.fields.DocumentDate
            });
          });
        } catch (error) {
          console.error(`Error fetching documents from list '${listName}':`, error);
        }

        return documents;
      };

      sharePointService.initialize()
        .then(async () => {
          sharePointService.getUserProfile();

          const customerId = context.serviceCall.companyId;
          
          //Call Id without dash
          const callid = context.serviceCall.serviceCallId;

          //For the Rigel reports, the callid is stored with a dash, 
          // for example C07C2024769 is stored as C07-C2024769 and C10C2024769 is stored as C10-C2024769. 
          // So we need to add a dash between the first 3 and 4 characters
          const callidWithDash = callid.slice(0, 3) + '-' + callid.slice(3);

          const customerAccountId = context.serviceCall.endUser;
          
          const query = `(startswith(fields/CallId, '${callid}') or startswith(fields/CallId, '${callidWithDash}')) and fields/CompanyId eq '${customerId}' and fields/CustomerAccount eq '${customerAccountId}' and  (fields/Portal eq 'Yes' or fields/Portal eq null or fields/Portal eq '')`;

          const taskReportsDocuments = await fetchAndProcessDocuments("DM_TaskReports", query);
          const rigelReportsDocuments = await fetchAndProcessDocuments("DM_RigelReports", query);

          const allDocuments = [...taskReportsDocuments, ...rigelReportsDocuments];

          context.callDocuments = allDocuments.concat(context.serviceCall.callDocuments);
        })
        .catch(error => {
          console.error("Error initializing SharePoint service:", error);
        });

      getUserInfo(context);
    })
    .catch(error => {
      console.log(error);
    });
}

function getUserInfo(context) {
  let promise = context.$axios.get('systemsettings/userinfo ');

  return promise
    .then(data => {
      const logins = data.data;
      var companyId = context.serviceCall.companyId;

      var salesGroupsIds = [];
      if (context.serviceCall.endUserCustomer !== null) {
        salesGroupsIds.push(context.serviceCall.endUserCustomer.salesGroupId);
      }
      if (context.serviceCall.contractHolderCustomer !== null) {
        salesGroupsIds.push(
          context.serviceCall.contractHolderCustomer.salesGroupId
        );
      }

      var salesGroupLogins = [];
      salesGroupsIds.forEach(sg => {
        logins.forEach(login => {
          if (login.salesGroupId === sg && login.companyId === companyId) {
            salesGroupLogins.push(login);
          } else if (
            login.salesGroupId.indexOf('*ALL-') !== -1 &&
            login.companyId === companyId
          ) {
            salesGroupLogins.push(login);
          } else if (
            login.salesGroupId.indexOf('clientAll') !== -1 &&
            login.companyId === companyId
          ) {
            salesGroupLogins.push(login);
          }
        });
      });

      salesGroupLogins.forEach(login => {
        if (login.roleId === 2 || login.roleId === 3) {
          context.canDeleteDocument = true;
        }
      });
    })
    .catch(error => {
      console.log(error);
    });
}
</script>

<style scoped>
.container {
  background-color: white;
  text-align: left;
}

.row {
  text-align: left;
}

.document-link {
  color: #007bff;
}

.document-link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.visit-address {
  font-family: 'Rubik', sans-serif;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1rem;
  color: #18385f;
  margin-bottom: 0;
  white-space: pre-wrap;
}
</style>
